import React from 'react'
import PropTypes from 'prop-types'

import { Container, Message } from 'semantic-ui-react'

import GlobalMessageContainer from './GlobalMessageContainer'

import * as styles from './styles'
import './styles.css'

const GlobalMessage = props => (
  <Container style={styles.container}>
    <Message
      className={props.className}
      content={props.message}
      error={props.error}
      floating
      header={props.header}
      icon={props.icon}
      onDismiss={props.handleDismiss}
      positive={props.positive}
      warning={props.warning}
    />
  </Container>
)

GlobalMessage.propTypes = {
  className: PropTypes.string.isRequired,
  error: PropTypes.bool.isRequired,
  handleDismiss: PropTypes.func.isRequired,
  header: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
  positive: PropTypes.bool.isRequired,
  warning: PropTypes.bool.isRequired,
}

export default GlobalMessageContainer(GlobalMessage)
